// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4a8c7b06","513":"05dc88c5","703":"8dca1ea2","787":"3718e89a"}[chunkId] + ".chunk.js";
};